import { render, staticRenderFns } from "./ComplianceCategory.vue?vue&type=template&id=065d2857"
import script from "./ComplianceCategory.vue?vue&type=script&lang=js"
export * from "./ComplianceCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports